import React from 'react'
import { useParams } from 'react-router-dom'

import reactQuery from '../../_helpers/reactQuery'
import { filterService } from '../../_services'
import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'
import AbstractDocument from '../Abstract/AbstractDocument'

const FitoutProject = function () {
  const singleQueryKey = 'filter'
  const params = useParams()
  const getQuery = reactQuery.getOneQuery(
    singleQueryKey,
    params.id,
    filterService.get
  )
  return (
    <>
      <AbstractDocument
        singleCollectionName="Fitout Project"
        notToShow={[
          'ancestorIds',
          'parentId',
          'images',
          'videos',
          'type',
          ...SLIDE_FIELDS,
          ...HOMEPAGE_FIELDS,
          ...LOCAL_BUSINESS_FIELDS,
        ]}
      />
      <AbstractCollection
        collectionName="Projects"
        singleCollectionName="Project"
        notToShow={[
          'ancestorIds',
          'parentId',
          'videos',
          'type',
          'createdAt',
          ...SLIDE_FIELDS,
          ...HOMEPAGE_FIELDS,
          ...LOCAL_BUSINESS_FIELDS,
        ]}
        toShow={['name', 'coverPhoto', 'createdAt']}
        type={typeConstant.CITY}
        parentId={getQuery.data ? getQuery.data.id : null}
        ancestorIds={
          getQuery.data
            ? `${
                getQuery.data.ancestorIds.length
                  ? `${getQuery.data.ancestorIds.join('')},`
                  : ''
              }${getQuery.data.id}`
            : null
        }
        navigate={['projects', '_id']}
      />
    </>
  )
}
export default FitoutProject
